import { Typography } from 'src/shared/components/ui';

/** Type of the icon components exported by `@heroicons/react` (e.g. `CheckIcon`). */
export type HeroIcon = React.ForwardRefExoticComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string;
    titleId?: string;
  } & React.RefAttributes<SVGSVGElement>
>;

interface EmptyTabStateProps {
  title: string;
  description: string;
  icon: HeroIcon;
  /** Optional call to action rendered below the description (e.g. a link). */
  action?: React.ReactNode;
}

const EmptyTabState: React.FC<EmptyTabStateProps> = ({
  title,
  description,
  icon: Icon,
  action
}) => {
  return (
    <div className="flex flex-1 flex-col justify-center items-center h-full">
      <div className="mb-4 size-20 bg-green-light-6 rounded-full flex justify-center items-center">
        <div className="size-8 bg-green-dark rounded-full flex justify-center items-center">
          <Icon className="size-5 text-white" />
        </div>
      </div>
      <Typography variant="h6" weight="bold">
        {title}
      </Typography>
      <Typography
        variant="body-2"
        weight="medium"
        className="text-secondary-text"
      >
        {description}
      </Typography>
      {action}
    </div>
  );
};

export default EmptyTabState;
